import { useState } from 'react'
import { toast } from 'react-toastify'

import { axiosInstance } from '../helpers'

export const useAreaLabels = () => {
    const [areaLabelCombinations, setAreaLabelCombinations] = useState<
        AreaLabelCombinations[]
    >([])

    const getAreaLabelCombinations = async (companyId?: number) => {
        try {
            const res = await axiosInstance.get(
                'apt_config/area_config/get_area_config_label_combinations/',
                companyId ? { params: { company_id: companyId } } : undefined,
            )
            const data: AreaLabelCombinations[] = res.data
            setAreaLabelCombinations(res.data)
            return data
        } catch (error) {
            toast.error(`Error fetching area label combinations: ${error}`)
            return Promise.reject(error)
        }
    }

    const updateAreaLabels = async (
        request: UpdateAreaLabelRequest,
        companyId?: number,
    ) => {
        try {
            await axiosInstance.post(
                'infrastructure/area/update_area_labels/',
                companyId ? { ...request, company_id: companyId } : request,
            )
        } catch (error) {
            toast.error(`Error updating area labels: ${error}`)
            return Promise.reject(error)
        }
    }

    return { areaLabelCombinations, getAreaLabelCombinations, updateAreaLabels }
}

export interface AreaLabelCombinations {
    area_config_id: number
    area_config_name: string
    area_label: string
}

export interface UpdateAreaLabelRequest {
    area_label_combinations: {
        area_config_id: number
        area_config_name: string
        current_area_label: string
        new_area_label: string
    }[]
}
